import React from "react";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  const auth = useSelector((state) => state.auth);
  //const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    // navigate('/');
    window.location.reload();
  };

  return (
    <div>
      <header className="main-header">
        <Link to="/home" className="logo">
          <span className="logo-mini">
            {auth?.user?.role === "Vendor" ? (
              <span>
                <b>Vendor</b>
              </span>
            ) : (
              <span>
                <b>Admin</b>
              </span>
            )}
          </span>
          <span className="logo-lg">
            {auth?.user?.role === "Vendor" ? (
              <span>
                <b>Vendor</b>Panel
              </span>
            ) : (
              <span>
                <b>Admin</b>Panel
              </span>
            )}
          </span>
        </Link>
        <nav className="navbar navbar-static-top">
          <a
            href="/#"
            className="sidebar-toggle"
            data-toggle="push-menu"
            role="button"
          >
            <span className="sr-only">Toggle navigation</span>
          </a>
          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown messages-menu">
                <a href="/#" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-envelope-o" />
                  <span className="label label-success">4</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have 4 messages</li>
                  <li>
                    <ul className="menu">
                      <li>
                        <a href="/#">
                          <div className="pull-left">
                            <img
                              src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                              className="img-circle"
                              alt="User"
                            />
                          </div>
                          <h4>
                            Support Team
                            <small>
                              <i className="fa fa-clock-o" /> 5 mins
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                      {/* end message */}
                      <li>
                        <a href="/#">
                          <div className="pull-left">
                            <img
                              src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                              className="img-circle"
                              alt="UserImage"
                            />
                          </div>
                          <h4>
                            AdminLTE Design Team
                            <small>
                              <i className="fa fa-clock-o" /> 2 hours
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <div className="pull-left">
                            <img
                              src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                              className="img-circle"
                              alt="UserImage"
                            />
                          </div>
                          <h4>
                            Developers
                            <small>
                              <i className="fa fa-clock-o" /> Today
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <div className="pull-left">
                            <img
                              src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                              className="img-circle"
                              alt="UserImage"
                            />
                          </div>
                          <h4>
                            Sales Department
                            <small>
                              <i className="fa fa-clock-o" /> Yesterday
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <div className="pull-left">
                            <img
                              src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                              className="img-circle"
                              alt="UserImage"
                            />
                          </div>
                          <h4>
                            Reviewers
                            <small>
                              <i className="fa fa-clock-o" /> 2 days
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer">
                    <a href="/#">See All Messages</a>
                  </li>
                </ul>
              </li>
              {/* Notifications: style can be found in dropdown.less */}
              <li className="dropdown notifications-menu">
                <a href="/#" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-bell-o" />
                  <span className="label label-warning">10</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have 10 notifications</li>
                  <li>
                    {/* inner menu: contains the actual data */}
                    <ul className="menu">
                      <li>
                        <a href="/#">
                          <i className="fa fa-users text-aqua" /> 5 new members
                          joined today
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fa fa-warning text-yellow" /> Very long
                          description here that may not fit into the page and
                          may cause design problems
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fa fa-users text-red" /> 5 new members
                          joined
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fa fa-shopping-cart text-green" /> 25
                          sales made
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fa fa-user text-red" /> You changed your
                          username
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer">
                    <a href="/#">View all</a>
                  </li>
                </ul>
              </li>
              {/* Tasks: style can be found in dropdown.less */}
              <li className="dropdown tasks-menu">
                <a href="/#" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-flag-o" />
                  <span className="label label-danger">9</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have 9 tasks</li>
                  <li>
                    {/* inner menu: contains the actual data */}
                    <ul className="menu">
                      <li>
                        {/* Task item */}
                        <a href="/#">
                          <h3>
                            Design some buttons
                            <small className="pull-right">20%</small>
                          </h3>
                          <div className="progress xs">
                            <div
                              className="progress-bar progress-bar-aqua"
                              style={{ width: "20%" }}
                              role="progressbar"
                              aria-valuenow={20}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <span className="sr-only">20% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      {/* end task item */}
                      <li>
                        {/* Task item */}
                        <a href="/#">
                          <h3>
                            Create a nice theme
                            <small className="pull-right">40%</small>
                          </h3>
                          <div className="progress xs">
                            <div
                              className="progress-bar progress-bar-green"
                              style={{ width: "40%" }}
                              role="progressbar"
                              aria-valuenow={20}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <span className="sr-only">40% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      {/* end task item */}
                      <li>
                        {/* Task item */}
                        <a href="/#">
                          <h3>
                            Some task I need to do
                            <small className="pull-right">60%</small>
                          </h3>
                          <div className="progress xs">
                            <div
                              className="progress-bar progress-bar-red"
                              style={{ width: "60%" }}
                              role="progressbar"
                              aria-valuenow={20}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <span className="sr-only">60% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      {/* end task item */}
                      <li>
                        {/* Task item */}
                        <a href="/#">
                          <h3>
                            Make beautiful transitions
                            <small className="pull-right">80%</small>
                          </h3>
                          <div className="progress xs">
                            <div
                              className="progress-bar progress-bar-yellow"
                              style={{ width: "80%" }}
                              role="progressbar"
                              aria-valuenow={20}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <span className="sr-only">80% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      {/* end task item */}
                    </ul>
                  </li>
                  <li className="footer">
                    <a href="/#">View all tasks</a>
                  </li>
                </ul>
              </li>
              {/* User Account: style can be found in dropdown.less */}
              <li className="dropdown user user-menu">
                <a href="/#" className="dropdown-toggle" data-toggle="dropdown">
                  <img
                    src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                    className="user-image"
                    alt="UserImage"
                  />
                  <span className="hidden-xs">
                    {auth.user.fname} {auth.user.lname}
                  </span>
                </a>
                <ul className="dropdown-menu">
                  {/* User image */}
                  <li className="user-header">
                    <img
                      src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                      className="img-circle"
                      alt="UserImage"
                    />
                    <p>
                      {auth.user.fname} {auth.user.lname} - Web Developer
                      <small>Member since Nov. 2012</small>
                    </p>
                  </li>
                  {/* Menu Footer*/}
                  <li className="user-footer">
                    <div className="pull-left">
                      <NavLink
                        to="/profile"
                        className="btn btn-default btn-flat"
                      >
                        Profile
                      </NavLink>
                    </div>
                    <div className="pull-right">
                      <a
                        href="/#"
                        className="btn btn-default btn-flat"
                        onClick={logout}
                      >
                        Sign out
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
              {/* Control Sidebar Toggle Button */}
              <li>
                <a href="/#" data-toggle="control-sidebar">
                  <i className="fa fa-gears" />
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </div>
  );
}
